define('controllers/conversations/Podio.Controllers.Conversations.New',['require','underscore','jquery','translate','lib/backbone/Backbone.PodioController','views/conversations/Podio.Views.Conversations.New','models/Podio.Models.Conversation','lib/Podio.UI.FlashMessage','lib/Podio.Transport.Picker','lib/Podio.UI.Modal','lib/Podio.Event.UI','lib/Podio.Event','lib/Podio.Utils','lib/Podio.Config'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var t = require('translate');
  var PodioController = require('lib/backbone/Backbone.PodioController');
  var ViewNewConversation = require('views/conversations/Podio.Views.Conversations.New');
  var ModelConversation = require('models/Podio.Models.Conversation');
  var FlashMessage = require('lib/Podio.UI.FlashMessage');
  var transportPicker = require('lib/Podio.Transport.Picker');
  var modal = require('lib/Podio.UI.Modal');
  var eventUI = require('lib/Podio.Event.UI');
  var podioEvent = require('lib/Podio.Event');
  var podioUtils = require('lib/Podio.Utils');
  var podioConfig = require('lib/Podio.Config');

  var controllerInstance = null;

  var ControllerNewConversation = PodioController.extend({

    shortcuts: {
      'm' : 'onShortcutPressed'
    },

    initialize: function(options) {
      this._super();
      _.bindAll(this, 'onConversationFormSubmit', 'onConversationCreated', 'onShortcutPressed');
      this.bindEvents();
    },

    bindEvents: function() {
      this.eventBus.bind('conversationForm:submit', this.onConversationFormSubmit, this);
    },

    unbindEvents: function() {
      this.eventBus.unbind('conversationForm:submit', this.onConversationFormSubmit, this);
    },

    onShortcutPressed: function() {
      if (podioUtils.loggedIn()) {
        this.show({hideProTip: true});
      }
    },

    onConversationFormSubmit: function(values) {
      // On the conversations page, we have the collection controller available, elsewhere we don't
      // TODO: This check might not be required when chat pane has been implemented
      if (this.options.conversationsCollectionController) {
        this.options.conversationsCollectionController.createConversation(values, this.onConversationCreated);
      } else {
        var self = this;
        var conversationModel = new ModelConversation(values);
        conversationModel.save().done(function(responseData) {
          if (responseData.status === 'ok') {
            conversationModel.set(responseData.data.conversation);
            self.onConversationCreated(conversationModel);
          } else {
            self.onConversationCreated(null, !responseData.error_propagate);
          }
        });
      }
    },

    onConversationCreated: function(conversation, errorNotPropagated) {
      if (_.isNull(conversation)) {           // creation failed
        if (errorNotPropagated) {
          FlashMessage.show(t('An unexpected error occured while adding your conversation. Please try again. #conversations'), 'error');
        }
        this.view.restoreAfterSubmit();
      } else {
        this.dispose();
      }
    },

    show: function(options) {
      options = options || {};

      // Dispose any view currently being shown
      this.dispose();

      // Check user property for pro tip being dismissed if not explictly set
      if (_.isUndefined(options.hideProTip)) {
        options.hideProTip = podioConfig.user.properties['conversation_hotkey_dismissed'];
      }

      // launch modal
      modal.show('', {
        title: t('Send message #conversations'),
        className: 'new-conversation',
        hideHandler: this.dispose,
        hideOnOutsideClick: false
      });

      // Render new conversation inside modal
      options = _.extend({
        el: $('.new-conversation .modal-content'),
        eventBus: this.eventBus
      }, this.options, options);
      this.view = new ViewNewConversation(options);
      this.view.render();

      $('.new-conversation .modal-content').css('maxHeight', modal.availableHeight());

    },

    dispose: function() {
      if (this.view) {
        modal.hide();
        this.view.dispose();
        this.view = null;
      }
      return true;
    }
  }, {

    // Class properties/methods
    getSingleton: function(options) {
      options = options || {};

      if (controllerInstance) {
        controllerInstance.unbindEvents();

        _.extend(controllerInstance.options, options);

        if (options.eventBus) {
          controllerInstance.eventBus = options.eventBus;
        }

        controllerInstance.bindEvents();
      } else {
        controllerInstance = new ControllerNewConversation(options);
      }
      return controllerInstance;
    },

    showWithPrePopulate: function(options) {
      var initController = function(prePopulate) {
        var newController = ControllerNewConversation.getSingleton();
        newController.show({
          userIds: options.userIds,
          subject: options.subject,
          text: options.text,
          prePopulate: prePopulate
        });
      };

      if (options.userIds && options.userIds.length) {
        modal.showLoading();
        transportPicker.getContactsData('single_user', options.userIds, function(responseData) {
          initController(responseData);
        });
      } else {
        initController();
      }
    }
  });

  function onGenericSendMessageLinkClicked(elmTarget, e) {
    var userId = elmTarget.data('send-message-user-id');

    var subject = elmTarget.data('send-message-subject');
    var text = elmTarget.data('send-message-text');
    var chatPaneAvailable = $('#header-global').find('.podio-chat').length > 0;

    if (chatPaneAvailable && !subject && !text && userId) {
      // We have exactly one other participants and no predefined subject or text
      // -> Start conversation in chat pane
      var newController = ControllerNewConversation.getSingleton();
      newController.eventBus.trigger('newConversationController:startDirectConversation', userId);
    } else {
      // We have 0 or many other participants, or predefined subject or text
      // -> Use conversation modal to start conversation
      ControllerNewConversation.showWithPrePopulate({
        userIds: userId ? [userId] : [],
        subject: subject,
        text: text
      });
    }
  }

  function onInit() {
    var newController = ControllerNewConversation.getSingleton();
    newController.enableShortcuts();
  }

  podioEvent.bind(podioEvent.Types.init, onInit);
  eventUI.bind('click', '.show-send-message-modal', onGenericSendMessageLinkClicked);

  return ControllerNewConversation;

});

